export enum SnapshotType {
  Backup  = 0,
  Publish = 1
}
